import { paths } from './paths'

export const moreLinks = {
  moreOverviewLink: () => ``,
  chatLink: () => `/${paths.CHAT}`,
  servicepointMapLink: () => `/${paths.SERVICEPOINT_MAP}`,
}
